import React from "react";
import "../../styles/loaders.css";

export const ButtonLoader1 = () => {
  return <span className="btn-loader-1"></span>;
};

export const ButtonLoader2 = () => {
  return <span className="btn-loader-2"></span>;
};
